
const cmdCtrl = (e) => (e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey);

const keyStr = (e) => String.fromCharCode(e.keyCode);

const markFunc = (mark) => (change) => change.toggleMark(mark);

const getHotkeyChange = (event) => {
  switch (keyStr(event)) {
    case 'B':
      return cmdCtrl(event) ? markFunc('bold') : null;
    case 'I':
      return cmdCtrl(event) ? markFunc('italic') : null;
    default:
      return null;
  }
};

const Hotkeys = () => ({
  onKeyDown(event, change, editor) {
    const markChange = getHotkeyChange(event);

    if (markChange) change.call(markChange);
  },
});

export default Hotkeys;
